<template>
    <div class="componentRoot">
        <ButtonRowVue>
            <template v-slot:leftSide>
                <v-col :cols="searchBarCols" class="pr-2">
                    <SearchBarVue :labelArray="['basics.name', 'basics.type']" @search="updateSearchQueue" />
                </v-col>
                <v-col v-if="activeType" cols="auto" style="display: flex; align-items: center;">
                    <v-card flat style="display: flex; align-items: center;" class="px-4">
                        <v-chip :color="activeType.color_code" @click="filterByType($event, activeType)">{{
                            activeType.name
                            }} <v-icon>mdi-close</v-icon></v-chip>
                    </v-card>
                </v-col>
            </template>


            <v-col cols="auto" v-if="$checkRouterPermission('POST')">
                <v-tooltip :text="$t('basics.new', { type: $t('basics.retreat') })">
                    <template v-slot:activator="{ props }">
                        <v-btn v-bind="props" @click="showEditRetreat($event)" class="primaryButton squareButton"
                            flat><v-icon size="x-large">mdi-plus</v-icon></v-btn>
                    </template>
                </v-tooltip>
            </v-col>
        </ButtonRowVue>

        <TableVue :numPages="numPages" @switchPage="switchPage" id="retreatTable" :resetPage="resetPage"
            :total="totalCount">
            <thead>
                <tr>
                    <th>
                        <b style="font-size: medium">{{ $t("basics.type") }}</b>
                    </th>
                    <th class="text-left" @click="switchSortBy('name')" :style="{
                        color: sortBy == 'name' ? 'rgb(var(--v-theme-primary))' : 'unset',
                    }">
                        <div style="display: flex; align-items: center">
                            <b style="font-size: medium">{{ $t("basics.name") }}</b>

                            <div v-if="sortBy == 'name'">
                                <v-icon v-if="!sortDirection">mdi-menu-up</v-icon>
                                <v-icon v-else>mdi-menu-down</v-icon>
                            </div>
                            <div v-else>
                                <v-icon>mdi-menu-right</v-icon>
                            </div>
                        </div>
                    </th>
                    <th  v-if=!isMobile>
                        <b style="font-size: medium">{{ $t("basics.description") }}</b>
                    </th>
                    <th v-if="!isMobile" class="text-left" @click="switchSortBy('price')" :style="{
                        color: sortBy == 'price' ? 'rgb(var(--v-theme-primary))' : 'unset',
                    }">
                        <div style="display: flex; align-items: center">
                            <b style="font-size: medium">{{ $t("basics.price") }}</b>
                            <div v-if="sortBy == 'price'">
                                <v-icon v-if="!sortDirection">mdi-menu-up</v-icon>
                                <v-icon v-else>mdi-menu-down</v-icon>
                            </div>
                            <div v-else>
                                <v-icon>mdi-menu-right</v-icon>
                            </div>
                        </div>
                    </th>
                    <th> <b style="font-size: medium">{{ $t("basics.status") }}</b></th>
                    <th></th>
                </tr>
            </thead>
            <tbody v-if="retreats && retreats.length > 0">
                <tr v-for="retreat in retreats" 
                @click="gotoRetreat($event, retreat)" @mousedown.middle="gotoRetreatInNewTab($event, retreat)" :key="retreat.id"
                >
                    <td>
                        <v-chip :color="retreat.type.color_code" @click="filterByType($event, retreat.type)">{{
                            retreat.type.name }}</v-chip>
                    </td>
                    <td>
                        {{ retreat.name }}
                    </td>
                    <td  v-if=!isMobile>
                        <span v-if="retreat.description && retreat.description.length > 60">
                            {{ retreat.description.substring(0,50) }}...
                        </span>
                         <span v-else-if="retreat.description">
                            {{ retreat.description }}...
                        </span>
                    </td>
                    <td  v-if=!isMobile>
                        {{ retreat.price }}€
                    </td>

                    <td>
                        <v-chip :color="statusColors[retreat.status]">{{ $t("constants.product_status_" +
                            retreat.display_status) }}</v-chip>
                    </td>
                    <td class="text-right">
                        <v-tooltip :text="$t('basics.edit', { type: $t('basics.retreat') })"  v-if="$checkRouterPermission('PATCH')">
                            <template v-slot:activator="{ props }">
                                <div @click="showEditRetreat($event, retreat)" :key="retreat.id">
                                <v-icon v-bind="props"> mdi-pencil </v-icon>
                                </div>
                            </template>
                        </v-tooltip>
                    </td>
                </tr>
            </tbody>

            <tbody v-else>
                <tr>
                    <td colspan="400">
                        <i>{{ $t("messages.noItems") }}</i>
                    </td>
                </tr>
            </tbody>
        </TableVue>

        <RetreatEditVue :refreshDisplay="editRetreatDrawer" @close="closeEditRetreat" :retreatData="activeRetreat"
            @delete="showDeleteRetreat"
            :readonly="!$checkRouterPermission('POST') && !$checkRouterPermission('PATCH')" />

        <DeletionWarningVue :type="'retreat'" :additionalMessage="$t('messages.confirmDeletionItem', { item: activeRetreat?.name })
            " :refreshDisplay="deleteRetreatDrawer" @delete="deleteRetreat" style="z-index: 1007 !important" />

        <LoadingScreenVue :loading="loading" />
    </div>
</template>

<script>
import RetreatEditVue from "../../../components/products/RetreatEdit.vue";

export default {
    name: "retreatList",

    data() {
        return {
            retreats: undefined,

            activeRetreat: undefined,
            editRetreatDrawer: 0,
            deleteRetreatDrawer: 0,

            currPage: 1,
            numPages: undefined,
            totalCount: undefined,
            resetPage: 0,

            activeType: undefined,

            searchQueue: undefined,
            searchParams: undefined,

            filterParams: undefined,

            sortBy: "name",
            sortDirection: true,

            loading: false,

            statusColors: [
                "rgb(var(--v-theme-success))",
                "rgb(var(--v-theme-error))",
            ]
        };
    },

    computed: {
        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
        searchBarCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 9;
                case "sm":
                    return 6;
                case "md":
                    return 4;
                case "lg":
                    return 4;
                case "xl":
                    return 4;
                case "xxl":
                    return 3;
                default:
                    return 4;
            }
        },
    },

    components: {
        RetreatEditVue,
    },

    methods: {
        filterByType(event, type) {
            event.stopPropagation()
            event.preventDefault()

            if (this.activeType && this.activeType.id == type.id) {
                this.activeType = undefined
            }
            else {
                this.activeType = type
            }

            this.fetchData()
        },
        getIcon(retreat) {
            switch (retreat.display_type) {
                case "hotel":
                    return "mdi-bunk-bed";
                case "campus":
                    return "mdi-table-chair";
                case "gym":
                    return "mdi-garage-open-variant";
                case "multiUse":
                    return "mdi-dots-horizontal-circle-outline";
                case "external":
                    return "mdi-open-in-new";
                default:
                    return "mdi-table-chair";
            }
        },
        fetchData() {
            this.setLoading(true);

            let searchParams =
                "?page=" +
                this.currPage +
                "&order=" +
                this.sortBy +
                "&direction=" +
                (this.sortDirection ? "up" : "down");

            if (this.searchParams) {
                searchParams += this.searchParams;
            }

            if (this.searchQueue) {
                searchParams += "&query=" + this.searchQueue;
            }

            if (this.filterParams) {
                searchParams += this.filterParams;
            }

            if (this.activeType) {
                searchParams += "&type=" + this.activeType.id
            }

            this.axios
                .get(this.axios.defaults.baseURL + "media/retreats/" + searchParams)
                .then((resp) => {
                    this.setLoading(false);
                    this.retreats = resp.data.results;
                    this.totalCount = resp.data.count;

                    if (resp.data.results.length == 0) {
                        this.numPages = 0;
                    } else if (this.currPage == 1) {
                        this.numPages = Math.ceil(resp.data.count / resp.data.results.length);
                    }
                })
                .catch((e) => {
                    this.setLoading(false);
                    console.log(e);
                    window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
                });
        },
        setLoading(value) {
            this.loading = value;
        },
        showEditRetreat(event, retreat) {
            event.preventDefault();
            event.stopPropagation();

            this.activeRetreat = retreat;
            this.editRetreatDrawer++;
        },
        gotoRetreat(event, retreat) {
            event.preventDefault();
            event.stopPropagation();

            if(!this.$checkFunctionPermission(["digital_media_detail"])){
                this.showEditRetreat(event, retreat)
                return
            }
            
            this.$router.push("/backoffice/products/retreat/" + retreat.id)
        },
        gotoRetreatInNewTab(event, retreat) {
            event.preventDefault();
            event.stopPropagation();

            if(!this.$checkFunctionPermission(["digital_media_detail"])){
                return
            }

            window.open("/backoffice/products/retreat/" + retreat.id, "blank")
        },
        closeEditRetreat(value) {
            this.activeRetreat = undefined;
            this.editRetreatDrawer = 0;

            this.setLoading(false);

            if (value) {
                this.fetchData();
            }
        },
        switchPage(data) {
            this.currPage = data;

            this.fetchData();
        },
        getReadableDatetime(datetime) {
            if (datetime) return this.$moment(datetime).format("DD.MM.YYYY HH:mm");
            else return undefined;
        },
        updateSearchQueue(value) {
            this.resetPage++;
            this.currPage = 1;
            this.searchQueue = value;

            this.fetchData();
        },
        switchSortBy(val) {
            if (this.sortBy != val) {
                this.sortBy = val;
                this.sortDirection = true;
            } else {
                this.sortDirection = !this.sortDirection;
            }

            this.currPage = 1;
            this.resetPage++;

            this.fetchData();
        },
        applyFilter(query) {
            this.resetPage++;
            this.filterParams = query;
            this.fetchData();
        },
        showDeleteRetreat() {
            this.deleteRetreatDrawer++;
        },
        deleteRetreat() {
            this.setLoading(true);
            this.axios
                .patch(
                    this.axios.defaults.baseURL +
                    "media/retreats/delete/" +
                    this.activeRetreat.id,
                    {
                        deleted: true,
                    }
                )
                .then(() => {
                    this.setLoading(false);
                    this.deleteRetreatDrawer = 0;
                    this.editRetreatDrawer = 0;
                    this.fetchData();
                })
                .catch((e) => {
                    this.setLoading(false);
                    console.log(e);
                    window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
                });
        },
    },
    mounted() {
        this.fetchData();
    },
};
</script>
